import { useTypedParams } from '@sorare/routing';

import { LeaderboardPage } from 'components/collections/LeaderboardPage';

import type { PageParams } from './__generated__/routeParams';

const MyClubSlugCollectionsLeaderboardPage = () => {
  const { collection, slug } = useTypedParams<PageParams>();
  return <LeaderboardPage collection={collection} slug={slug} />;
};

export default MyClubSlugCollectionsLeaderboardPage;
